/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/TextArea/theme';

export const TextAreaTheme = theme;
